import React, { Component } from 'react';
import { Col, Row, Label, Input, InputGroup } from 'reactstrap';
import MaterialIcon from "material-icons-react";
import i18n from "../../../../i18next";

class PaymentTypesList extends Component {

    renderAllTenderTypes() {
        const { checkboxInput } = this.props.styles;
        const { tenderTypes } = this.props;

        if (tenderTypes !== undefined && tenderTypes !== null) {
            return tenderTypes.map((tenderType, i) => {

                const transformToLocalize = () => {
                    switch (tenderType.value) {
                        case "Credit card":
                            return "creditCard";
                        case "Cash":
                            return "cash";
                        case "Coupon":
                            return "coupon";
                        case "Stripe":
                            return "stripe";
                        case "Authipay":
                            return "authipay";
                        default:
                            return;
                    }
                }

                return (
                    <InputGroup key={tenderType.id + i}>
                        <Label for={tenderType.value}>{i18n.t(`common:paymentTypes.${transformToLocalize(tenderType.value)}`)}</Label>
                        <Input type="checkbox" name={tenderType.value} id={tenderType.id} style={checkboxInput}
                            checked={this.checkedIfMatches(tenderType.id)}
                            onChange={this.props.changeSelectedTenderTypesState} />
                    </InputGroup>
                );
            });
        }
    }

    checkedIfMatches(tenderTypeId) {
        const { supportedTenderTypes } = this.props;

        if (supportedTenderTypes !== undefined && supportedTenderTypes !== null && supportedTenderTypes.length > 0) {
            for (let i = 0; i < supportedTenderTypes.length; i++) {
                const currentTenderType = supportedTenderTypes[i];

                if (currentTenderType.id == tenderTypeId) {
                    return true;
                }
            }
        }

        return false;
    }

    render() {
        const { headerStyle, headerTitle, rowStyler, columnGroup, containerStyle } = this.props.styles;

        return (
            <Col style={containerStyle}>
                <Row>
                    <div style={headerStyle}>
                        <MaterialIcon icon="local_atm" color="#000" size={20} color="#0288d1"/>
                        <span style={headerTitle}>{i18n.t('common:deliveryCollectionDineInCurbside.paymentTypes')}</span>
                    </div>
                </Row>
                <Row style={rowStyler}>
                    <Col style={columnGroup}>{this.renderAllTenderTypes()}</Col>
                </Row>
            </Col>
        );
    }
}

export default PaymentTypesList;


// WEBPACK FOOTER //
// ./src/components/restaurants/settings/service/PaymentTypesList.js